import React from 'react'
import loginStyles from './styles'
import Icon from '@/components/HeroIcons'
import { TimeZoneGMT } from '@conexasaude/hero-web'
import ProtectedStamp from '@/components/ProtectedSiteStamp'

const PageLayout: React.FC = ({ children }) => {
  const { container, containerBackground, containerIcon } = loginStyles()
  return (
    <div css={containerIcon}>
      <div css={containerBackground}>
        <div className="background__container">
          <div className="background__noise" />
          <Icon
            name="character-media-player"
            className="background__container__icon"
            width={'560px'}
          />
          <h1>Olá, nós somos a Conexa Saúde</h1>
          <h3>Seu novo jeito de cuidar da saúde</h3>
        </div>
      </div>
      <div css={container}>
        <div className="content">{children}</div>
        <div className="footer">
          <TimeZoneGMT />© 2021 Conexa Saúde · Todos os direitos reservados.
          <div className="stamp-login">
            <ProtectedStamp />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageLayout
